<template>
  <Modal
    sm
    hide-footer
    :title="$t('onlinePayment')"
    :value="value"
    @input="$emit('input', $event)"
  >
    <p>{{ $t("paymentTypeDesc") }}</p>
    <div class="u-display-flex row-gap-10 u-margin-top">
      <Button
        variant="light-primary"
        class="u-border"
        block
        @click="$emit('input', false)"
      >
        {{ $t("common.cancel") }}
      </Button>
      <Button variant="primary" block @click="routerPush()">
        {{ $t("onlinePayment") }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Base/Modal.vue";
import Button from "../Base/Button.vue";
export default {
  components: { Modal, Button },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reservation: {
      type: Object,
      required: true,
    },
  },
  methods: {
    routerPush() {
      console.log(this.reservation);
      this.$router.push({
        name: "pay",
        params: {
          id: this.reservation.id,
        },
      });
    },
  },
};
</script>

<style></style>
